import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import LinkButton from 'flarum/common/components/LinkButton';

export default () => {
    cheatpanel();
}

function cheatpanel() {
    extend(SessionDropdown.prototype, 'items', (items) => {
        // remove night mode link from session dropdown
        if (app.forum.attribute('fofNightMode.showThemeToggleOnHeaderAlways')) {
            // fof-nightmode uses two item names
            items.remove('nightmode'); items.remove('daymode');
        }

        // add applications and cheatpanel links
        const user = app.session.user;
        if (user) {
            if (user.id() != 1) {
                // remove admin panel from all other users :)
                items.remove('administration');
            }
            // add applications link
            const isSuspended = user.suspendedUntil && (user.suspendedUntil() >= new Date());
            if (!isSuspended) {
                items.add(
                    'applications',
                    <LinkButton icon='fas fa-th' href={app.route('applications')}>
                        {  app.translator.trans('xtreh-phoenix.forum.applications.label') }
                    </LinkButton>,
                    50
                );
            }
            // add cheat-panel link
            if (!isSuspended && app.forum.attribute('canViewApplications')) {
                items.add(
                    'cheatpanel',
                    <LinkButton icon='fas fa-crosshairs' href={app.route('cheatpanel')}>
                        {  app.translator.trans('xtreh-phoenix.forum.cheatpanel.label') }
                    </LinkButton>,
                    25
                );
            }
        }
    });
}
